import { cn } from '@cobliteam/ui/utils';
import { type HTMLAttributeAnchorTarget, type ReactNode, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useVisitedPage } from '../hooks';

interface LinkWrapperProps {
  to: string;
  pageId: string;
  children: ReactNode;
  className?: string;
  target?: HTMLAttributeAnchorTarget;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: (path: string) => void;
  onPageClick?: (path: string) => void;
}

const LinkWrapper = ({ to, pageId, children, className, target = '_self', onClick, onMouseEnter, onMouseLeave, ...props }: LinkWrapperProps) => {
  const { trackPageVisit } = useVisitedPage();

  const handleClick = useCallback(() => {
    // Track the page visit
    if (pageId) {
      trackPageVisit(pageId);
    }

    // Call the original onClick if provided
    if (onClick) onClick(to);
  }, [to, pageId, trackPageVisit, onClick]);

  return (
    <Link
      to={to}
      target={target}
      className={cn('line-clamp-1 flex flex-row text-ellipsis active:text-current', className)}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...props}
    >
      {children}
    </Link>
  );
};

export default LinkWrapper;
